if (!customElements.get("video-media")) {
  customElements.define(
    "video-media",
    class VideoMedia extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector("video");
        this.started = false;

        this.lazyLoadObserve();
      }

      lazyLoadObserve() {
        if ("IntersectionObserver" in window) {
          let lazyVideoObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach(function (video) {
              if (video.isIntersecting) {
                for (var source in video.target.children) {
                  let videoSource = video.target.children[source];
                  if (
                    typeof videoSource.tagName === "string" &&
                    videoSource.tagName === "SOURCE"
                  ) {
                    videoSource.src = videoSource.dataset.src;
                  }
                }
                video.target.load();
                video.target
                  .play()
                  .then(() => {
                    //terrible mobile object-fit hack
                    setTimeout(() => {
                      video.target.classList.remove("loading");
                    }, 500);
                  })
                  .catch((error) => {
                    //terrible low powermode hack
                    console.log("Video Error Detected");
                  });

                lazyVideoObserver.unobserve(video.target);
              }
            });
          });
          lazyVideoObserver.observe(this.video);
        }
      }

      // playPauseObserve() {
      //   if ("IntersectionObserver" in window) {
      //     let playPauseObserver = new IntersectionObserver(function (
      //       entries,
      //       observer
      //     ) {
      //       entries.forEach(function (video) {
      //         if (video.isIntersecting) {
      //           console.log("in view, play");
      //           video.target.play();
      //           video.target.classList.add("playing");
      //         } else {
      //           console.log("out of view, pause");
      //           video.target.pause();
      //           video.target.classList.remove("playing");
      //         }
      //       });
      //     });
      //     playPauseObserver.observe(this.video);
      //   }
      // }
    }
  );
}
